module.exports = __webpack_public_path__ + "media/assets/images/events/matteo-interview-small-92bfd3204a98c04141102c37287eecd8.png";